export default function clubArea() {

    // Permette di usare un underscore "_" nelle stringhe per andare a capo
    function tspace(s) {
        return s.replace("_", "\r\n");
    }

    // A.Scapin: funzione che inizializza il validator dei 2 form "Area Club"
    if (typeof window.initFormsValid2 === 'undefined') {
        window.initFormsValid2 = function (validator_url, login_url, post_page_url, internal_page_url, map_page_url, pdf_page_url) {
            $('#login-form').submit(function (event) {
                var isOkToGo = true;
                event.preventDefault();

                $('.page-loader').addClass('show'); // mostra loader

                // rimuove tutte le indicazioni di errore
                $('#errlogin').html('');
                $('#login-form').find('.field-error').removeClass("field-error");

                // Valida mail
                var email = $('#username').val();
                var pattern = /^\b[-A-Z0-9._%-+]+@[-A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
                if (!pattern.test(email)) {
                    $('#errlogin').html(wp.i18n.__("Please type a valid email.", "cadelbosco"));
                    $('#username').addClass('field-error');
                    $('.page-loader').removeClass('show'); // nasconde eventuale loader
                    isOkToGo = false;
                }

                if (isOkToGo) {
                    $.ajax({
                        type: 'POST',
                        url: login_url,
                        data: $('#login-form').serialize(),
                        success: function (response) {
                            if (!response.status) {
                                $('#errlogin').html(response.message).fadeIn();
                                $('.page-loader').removeClass('show'); // nasconde eventuale loader
                                return false;
                            }
                            // All OK go!
                            // check if there is main page url to redirect
                            switch (response.page) {
                                case 'map': internal_page_url = map_page_url.length ? map_page_url : internal_page_url ;
                                    break;
                                case 'pdf': internal_page_url = pdf_page_url.length ? pdf_page_url : internal_page_url;
                                    break;
                                default:
                            }
                            $.redirect(internal_page_url, $('#login-form').serialize());
                        }
                    });
                }

            });

            $('#register-form').submit(function (event) {
                event.preventDefault();

                // rimuove tutte le indicazioni di errore
                $('#errregister').html('');
                $('#register-form').find('.field-error').removeClass("field-error");

                // questi devo validarli prima (o comunque separatamente)
                var checkboxes = document.querySelectorAll(`[data-required='${1}']`);
                var isOkToGo = true;
                if (checkboxes.length) {
                    $.each(checkboxes, function (key, obj) {
                        if (!obj.checked) {
                            $('#errregister').html(wp.i18n.__("Please accept all required flags.", "cadelbosco"));
                            $('#' + obj.id).parent().addClass('field-error');
                            isOkToGo = false;
                        }
                    })
                }
                if (!isOkToGo) return false;

                if (isOkToGo) {
                    $('.page-loader').addClass('show'); // mostra loader
                    $.ajax({
                        type: 'POST',
                        url: validator_url,
                        data: $('#register-form').serialize(),
                        success: function (response) {
                            if (!response.status) {
                                $('.page-loader').removeClass('show'); // nasconde eventuale loader
                                $('#errregister').html(response.message).fadeIn();
                                $('#' + response.field).addClass('field-error');
                                return false;
                            }
                            // All OK go!
                            $.redirect(post_page_url, $('#register-form').serialize());
                        }
                    });
                }
            });

        }
    }

    // A.Scapin: funzione che esegue il LOGOUT dall'Area Club
    if (typeof window.initAC2 === 'undefined') {
        window.initAC2 = function (logout_url, message_page_url, logoutMessage, errorMessage) {
            if ($('#logoutbtn').length) {
                $('#logoutbtn').click(function () {
                    $('.page-loader').addClass('show'); // mostra loader

                    $.ajax({
                        type: 'POST',
                        url: logout_url,
                        data: 0,
                        success: function (response) {
                            $('.page-loader').removeClass('show'); // nasconde eventuale loader
                            if (response.status) {
                                // All OK go!
                                $.redirect(message_page_url, {formname: 'logout'});
                            } else {
                                alert(errorMessage);
                            }
                        }
                    });
                });
            }
        }
    }

    if (typeof window.initializeSectionInfiniteScroll === 'undefined') {
        window.initializeSectionInfiniteScroll = function (myACurl) {

            //* A.Scapin: variabili e funzioni necessarie alla ricerca dell'Area Club
            var searchTextSubmit = document.querySelector('#search_text_submit');
            var searchText = document.querySelector('#search_text');
            var searchSelectType = document.querySelector('#search_select_tipologie');
            var searchSelectYears = document.querySelector('#search_select_anni');

            window.ACsearchUrl = myACurl;

            let infScroll = new InfiniteScroll('.press-list', {
                path: '.pagination__next',
                append: '.press-list .item',
                history: false,
                status: '.page-load-status',
                hideNav: '.pagination'
            });

            if (searchTextSubmit) {
                searchTextSubmit.addEventListener('click', function (e) {
                    e.preventDefault();
                    search_text();
                    return false;
                });
            }

            if (searchText) {
                searchText.addEventListener("keypress", function (event) {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        search_text();
                    }
                });
            }

            if (searchSelectType) {
                searchSelectType.addEventListener("change", search_select);
            }
            if (searchSelectYears) {
                searchSelectYears.addEventListener("change", search_select);
            }

            //textbox
            function search_text() {
                var testo_cercato = searchText.value;
                var tipo = searchSelectType.value;
                var anno = searchSelectYears.value;
                if (!tipo || tipo.length <= 0) {
                    tipo = 'all';
                }
                if (!anno || anno.length <= 0) {
                    anno = 'all';
                }
                const urlParams = new URLSearchParams(window.location.search);

                if ((testo_cercato && testo_cercato.length > 0) || (urlParams.get('ackw').length > 0)) {
                    if (window.ACsearchUrl.indexOf("?") > -1) {
                        location = window.ACsearchUrl + "&ackw=" + encodeURIComponent(testo_cercato) + "&actp=" + tipo + "&acyr=" + anno;
                    } else {
                        location = window.ACsearchUrl + "?ackw=" + encodeURIComponent(testo_cercato) + "&actp=" + tipo + "&acyr=" + anno;
                    }
                } else {
                    return false;
                }
            }

            //select
            function search_select() {
                var testo_cercato = searchText.value;
                var tipo = searchSelectType.value;
                var anno = searchSelectYears.value;
                if (!tipo || tipo.length <= 0) {
                    tipo = 'all';
                }
                if (!anno || anno.length <= 0) {
                    anno = 'all';
                }
                if (window.ACsearchUrl.indexOf("?") > -1) {
                    location = window.ACsearchUrl + "&ackw=" + encodeURIComponent(testo_cercato) + "&actp=" + tipo + "&acyr=" + anno;
                } else {
                    location = window.ACsearchUrl + "?ackw=" + encodeURIComponent(testo_cercato) + "&actp=" + tipo + "&acyr=" + anno;
                }
            }
        }
    }

    if ($('#reset-pwd-form').length) {
        const reset_password_url = typeof window.cdbResetPwdParams !== "undefined" && window.cdbResetPwdParams.reset_password_url ? window.cdbResetPwdParams.reset_password_url : '';
        $('#reset-pwd-form').submit(function (event) {
            var isOkToGo = true,
                form = $('#reset-pwd-form'),
                errorMsg = $('#errReset'),
                pageLoader = $('.page-loader');
            event.preventDefault();

            pageLoader.addClass('show'); // mostra loader

            // rimuove tutte le indicazioni di errore
            errorMsg.html('');
            form.find('.field-error').removeClass("field-error");

            // Valida mail
            var email = $('#username').val();
            var pattern = /^\b[-A-Z0-9._%-+]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
            if (!pattern.test(email)) {
                errorMsg.html(wp.i18n.__("Please type a valid email.", "cadelbosco"));
                $('#username').addClass('field-error');
                pageLoader.removeClass('show'); // nasconde eventuale loader
                isOkToGo = false;
            }

            if (isOkToGo) {
                $.ajax({
                    type: 'POST',
                    url: reset_password_url,
                    data: {email: $('#username').val()},
                    success: function (response) {
                        if (!response.status) {
                            errorMsg.html(response.message).fadeIn();
                            pageLoader.removeClass('show'); // nasconde eventuale loader
                            return false;
                        }
                        // All OK go!
                        form.html('');
                        $('#reset-pwd-form-response').html(response.message);

                        pageLoader.removeClass('show'); // nasconde eventuale loader
                    }
                });
            }
        });
    }
}